/**
 * Where an operation writes its result: a structure it creates, or an
 * existing structure it overwrites. An overwrite starts with `roiNumber`
 * null, and the operation cannot run until the user picks the structure.
 */
export type OutputTarget =
    | { kind: 'new' }
    | { kind: 'existing'; roiNumber: number | null };

export const NEW_OUTPUT_TARGET: OutputTarget = { kind: 'new' };

/** The overwrite of structure `roiNumber`, or of none picked yet. */
export function overwriteTarget(roiNumber: number | null): OutputTarget {
    return { kind: 'existing', roiNumber };
}

/** The structure the target overwrites, or null when it overwrites none. */
export function overwrittenRoiNumber(target: OutputTarget): number | null {
    return target.kind === 'existing' ? target.roiNumber : null;
}

/** Overwrite is chosen and no structure is picked: nothing to write to. */
export function isOverwriteUnpicked(target: OutputTarget): boolean {
    return target.kind === 'existing' && target.roiNumber === null;
}
